import React, { Component } from "react";
import {
  Col,
  Row,
  Nav,
  Card,
  Table,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,

} from "@themesberg/react-bootstrap";
import { FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import Select from 'react-select';
import { faEnvelope, faPhone, faLock, faPencilAlt, faAddressCard, faUnlockAlt, faEyeSlash, faEye, faLocationArrow, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import { addTermination, editTermination} from "../../services/terminationService";
import AsyncSelect from "react-select/async";
import ReactDatetime from "react-datetime";
import moment from "moment"

export class EditTermination extends Component {
  constructor(props) {
    super(props);
    this.state = {
    
      employees: props.employees,
      termination_date: moment().startOf('month'),
      termination_types:props.termination_types,
      notice_date: moment().startOf('month'),
      id: props.termination.id,
      // terminated_employee_id:props.termination.employee_id,
      termination: props.termination

    };
  }

  componentDidMount() {
    toast.configure({ hideProgressBar: true, closeButton: false });
  
   
  }

 
  dateFilter = async (e, state) => {
    await this.setState({ [state]: e })
  }

  onSaveTermination = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const {termination_date,termination_type_id, notice_date, description, employee_id,}=this.state.termination;
    const {  validation } = this.state;
    await this.setState({
      validation: {
        ...validation,
        // employee_id: employee_id !== '' && employee_id !== undefined,
        notice_date: notice_date !== '' && notice_date !== undefined,
        termination_date: termination_date !== '' && termination_date !== undefined,
        termination_type_id: termination_type_id !== '' && termination_type_id !== undefined,
        description: description !== '' && description !== undefined,
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveTermination();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field === "employee_id") {
      return "Employee Name  is required";
    } else if (field == 'notice_date') {
      return "Notice Date is required"
    } else if (field == 'termination_date') {
      return "Termination Date is required"
    } else if (field == 'description') {
      return "Description is required"
    } else if (field == 'termination_type_id') {
      return "Termination Type is required"
    }
  };





  saveTermination = () => {
    this.setState({ saving: true });
    const { termination, id } = this.state;
    
    editTermination({
      employee_id: termination.employee_id,
      termination_date: termination.termination_date,
      termination_type_id: termination.termination_type_id,
      description: termination.description,
      notice_date: termination.notice_date,
      id:id


    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false, saving:false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Termination has been updated");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occured')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };

  

  showToast = msg => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  }
  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };

  onChange = (e, state) => {
    const { termination } = this.state

    this.setState({ termination: { ...termination, [state]: e } })
  }

  

  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };






  render() {

    const { toggle } = this.props;

    const { saving, edit, termination, termination_types, employees, loading } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={termination != null}
          toggle={() => !loading && !saving && toggle}
          style={{ maxWidth: 700 }}
        >
          {saving && <SpinDiv text={"Saving..."} />}
          {loading && <SpinDiv text={"loading..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            <div className="btn-toolbar mb-2 mb-md-0">
             <h5>Restore/ Disable Termination</h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
            <Row>
            <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Employee</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      disabled
                      value={termination.employee_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "employee_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Select Employee</option>
                      {employees.length == 0 && <option value="">loading</option>}
                      {employees.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Termination Type</Form.Label>

                    <Form.Select
                      id="state"
                      disabled
                      required
                      value={termination.termination_type_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "termination_type_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">choose Termination Type</option>
                      {termination_types.length == 0 && <option value="">loading</option>}
                      {termination_types.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                

              </Row>
              
              <Row>
                <Col md="6">
                  <FormGroup className="form-date">
                    <label
                      className="form-control-label"
                      htmlFor="input-address"
                    >
                      Termination Date
                    </label>
                    <ReactDatetime
                      disabled
                      value={moment(termination.termination_date).format('MMM DD, YYYY') || ''}
                      dateFormat={'MMM D, YYYY'}
                      closeOnSelect
                      onChange={e => this.dateFilter(e, 'termination_date')}
                      inputProps={{
                        required: true,
                        className: 'form-control date-width'
                      }}
                      timeFormat={false}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup className="form-date">
                    <label
                      className="form-control-label"
                      htmlFor="input-address"
                    >
                      Notice Date
                    </label>
                    <ReactDatetime
                     value={moment(termination.notice_date).format('MMM DD, YYYY') || ''}
                      dateFormat={'MMM D, YYYY'}
                      disabled
                      closeOnSelect
                      onChange={e => this.dateFilter(e, 'notice_date')}
                      inputProps={{
                        required: true,
                        className: 'form-control date-width'
                      }}
                      timeFormat={false}
                    />
                  </FormGroup>
                </Col>
                
                
              </Row>

              <Row>
                <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Description</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      placeholder='Enter Description'
                      value={termination.description}
                      disabled
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "description");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>

              </Row>
              <Row>

              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSaveTermination}
                    >
                      Restore
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditTermination;
